import { FC } from "react";

import ErrorBoundary from "web/Layout/ErrorBoundary";

import type { PropsWithClasses } from "web/types/Common";

import { IProductCardProps } from "../container";
import Product from "./product";

export type ProductCardCarouselProps = Pick<
  IProductCardProps,
  | "product"
  | "listingPosition"
  | "listingAmount"
  | "listingCategory"
  | "gtmProduct"
  | "positionNumber"
  | "carouselLength"
>;

const ProductCardCarouselContainer: FC<
  PropsWithClasses<ProductCardCarouselProps>
> = ({
  classes,
  product,
  gtmProduct,
  positionNumber,
  carouselLength,
  listingPosition,
  listingAmount,
  listingCategory,
}) => {
  return (
    <ErrorBoundary>
      <Product
        classes={classes}
        product={product}
        gtmProduct={gtmProduct}
        positionNumber={positionNumber}
        carouselLength={carouselLength}
        listingPosition={listingPosition}
        listingAmount={listingAmount}
        listingCategory={listingCategory}
      />
    </ErrorBoundary>
  );
};

export default ProductCardCarouselContainer;
